import React, {FC, FocusEvent, MouseEvent, ReactNode} from 'react'
import {useDebounce} from "@hooks/debounce/useDebounce";
import InputCustom from "@ui/inputs/InputCustom";
import {SxType} from "@baseTypes/sx/sxTypes";


interface IProps {
    initialValue: string,
    onChange: (value: string) => void,
    error?: boolean,
    errorMessage?: string,
    name?: string,
    fullWidth?: boolean,
    size?: 'small',
    label?: string,
    multiline?: boolean,
    rows?: number,
    disabled?: boolean,
    InputProps?: {
        startAdornment?:ReactNode,
        endAdornment?:ReactNode,
    },
    inputProps?:{
        type?: 'number',
        min?: number,
        max?: number,
    },
    delay?: number,
    sx?: SxType,
    placeholder?:string
    onClick?: (event: MouseEvent<HTMLDivElement>) => void
    onFocus?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}

const InputDebounce: FC<IProps> = ({
                                       initialValue = '',
                                       onChange,
                                       delay = 700,
                                       fullWidth = true,
                                       label,
                                       size = 'small',
                                       error,
                                       errorMessage,
                                       name,
                                       multiline,
                                       rows,
                                       InputProps,
                                       inputProps,
                                       sx,
                                       placeholder,
                                       onFocus,
                                       onClick,
                                   }) => {

    const [value, setValue] = React.useState(initialValue)
    const {debouncedValue} = useDebounce<string>({value, delay})
    const firstChange = React.useRef<boolean>(null)

    React.useEffect(() => {
        if (!onChange) {
            return
        }
        if (!firstChange && initialValue === debouncedValue) {
            firstChange.current = true;
            return
        }
        onChange(debouncedValue as string)

    }, [debouncedValue])

    React.useEffect(() => {
        setValue(initialValue)

    }, [initialValue])

    return (
        <InputCustom
            rows={rows}
            multiline={multiline}
            fullWidth={fullWidth}
            size={size}
            label={label}
            value={value}
            onChange={setValue}
            error={error}
            name={name}
            errorMessage={errorMessage}
            InputProps={InputProps}
            inputProps={inputProps}
            sx={sx}
            placeholder={placeholder}
            onFocus={onFocus}
            onClick={onClick}
        />
    )
};

export default InputDebounce;